import { Lock } from "lucide-react";

export function UpgradeTeaser({ feature, requiredPlan, compact = false }: { feature: string; requiredPlan: string; compact?: boolean }) {
  return (
    <div className={`flex flex-col items-center justify-center text-center rounded-2xl border border-dashed border-amber-300 bg-amber-50/60 dark:bg-amber-950/20 ${compact ? "py-6 px-4" : "py-14 px-6"}`}>
      <div className="w-10 h-10 rounded-xl bg-amber-100 dark:bg-amber-900/40 flex items-center justify-center mb-3">
        <Lock className="w-5 h-5 text-amber-600" />
      </div>
      <div className="font-semibold text-sm text-amber-800 dark:text-amber-300 mb-1">{feature} requires {requiredPlan}</div>
      <div className="text-xs text-amber-600 dark:text-amber-400">Upgrade your plan to access this feature.</div>
    </div>
  );
}
